import {remote} from '../constants/environment';
import {ISemaphoreValue} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {ISemaphoreResponse} from '../interfaces/services/semaphore-response.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IPortfolioFilter} from '../context/commons/interfaces';

export const getSemphoreItems = async (
  token: string,
  filter?: IPortfolioFilter | null,
): Promise<ISemaphoreResponse> => {
  const remoteURI = remote.getSemaphoreUri();
  const body = filter
    ? JSON.stringify({
        payload: filter ?? null,
      })
    : {};
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: filter ? 'POST' : 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        ...body,
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();
        if (data.success && data.payload) {
          const success = true;

          const payloadData = data.payload as ISemaphoreValue[];
          return {
            success,
            payload: payloadData.sort((item1, item2) => {
              if (item1.order < item2.order) {
                return -1;
              } else if (item1.order === item2.order) {
                return 0;
              }
              return 1;
            }),
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as ISemaphoreResponse;
};
